import { IFooter, IFooterLink } from '../../../interfaces/IFooter';

import { FooterContactInfo } from './FooterContactInfo';
import { FooterIcons } from './FooterIcons';
import { FooterLink } from './FooterLink';
import { Seal } from '../../../components/Seal/Seal';
import React from 'react';
import { __ } from '../../../helpers/TranslationService';
import styled from '@emotion/styled';

class FooterLinkList extends React.Component<{ list: IFooterLink[] }, {}> {
    render() {
        return (
            <ul className="list-unstyled">
                {this.props.list
                    ? this.props.list.map((item, key) => (
                        <li key={key}>
                            <FooterLink {...item} />
                        </li>
                    ))
                    : ''}
            </ul>
        );
    }
}

const FootLinkGroupLi = styled.li`
    flex-grow: 1;
`;
export class FooterLinkGroup extends React.Component<{ title: string; list: IFooterLink[] }, {}> {
    render() {
        return (
            <FootLinkGroupLi>
                <h3 className="text-uppercase">{this.props.title}</h3>
                <FooterLinkList list={this.props.list} />
            </FootLinkGroupLi>
        );
    }
}

interface IProps {
    brandConfig: any;
    footer: IFooter;
    pageType: string;
}

const FooterNavUl = styled.ul`
    display: flex;
`;

const FooterBorderBottom = styled.div`
    border-bottom: 1px solid #c3c3c3;
`;

const marginBottom = {
    marginTop: '20px',
}

export class FooterNav extends React.Component<IProps, any> {
    render() {
        const { brandConfig, footer, pageType } = this.props;
        const showSeal = brandConfig.portalId == 'dreamlines.de';

        return (
            <div className="row">
                <div className="container">
                    <FooterIcons
                        portalId={brandConfig.portalId}
                        socialMediaIcons={footer.socialMediaIcons}
                        paymentMethods={footer.paymentMethods}
                        awards={footer.awards}
                        security={footer.security}
                    />

                    {showSeal &&
                        <>
                            <FooterBorderBottom />
                            <Seal
                                pageType={pageType}
                                isFooter={true}
                            />
                            <div style={marginBottom}></div>
                            <FooterBorderBottom />
                        </>
                    }

                    <nav className="footer_nav">
                        <FooterNavUl>
                            <FooterLinkGroup
                                title={footer.columnOne.headline}
                                list={footer.columnOne.items}
                            />
                            <FooterLinkGroup
                                title={footer.columnTwo.headline}
                                list={footer.columnTwo.items}
                            />
                            <FooterLinkGroup
                                title={footer.columnThree.headline}
                                list={footer.columnThree.items}
                            />
                            <FooterLinkGroup
                                title={footer.columnFour.headline}
                                list={footer.columnFour.items}
                            />
                            <FooterLinkGroup
                                title={footer.columnFive.headline}
                                list={footer.columnFive.items}
                            />
                            <FooterContactInfo
                                {...footer.contactInfo}
                                title={__('About us', 'dreamlines')}
                            />
                        </FooterNavUl>
                    </nav>

                    <div className="col-xs-12 noPadding">
                        <small>{footer.copyright}</small>
                    </div>
                </div>
            </div>
        );
    }
}
